import type { FC } from "react";
import IntelligenceText from "../types/IntelligenceText";
import { Box, Icons } from "@analyticsMD/quil";
import { css } from "@emotion/css";
import { blue } from "@mui/material/colors";
import { Tooltip } from "@mui/material";

interface intelligenceTextProps {
  intelligenceText: IntelligenceText;
}
const styles = {
  input: css`
    flex-direction: column;
    font-size: 0.688rem;
    align-items: center;
    text-align: center;
    padding: 0.6rem 1rem;
    font-size: 0.875rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
};

const sxStyles = {
  wrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    width: "100%",
    backgroundColor: blue[50],
    borderRadius: "0.4rem",
    border: `1px solid ${blue[100]}`,
  },
};

const IntelligenceTextDisplay: FC<intelligenceTextProps> = ({
  intelligenceText,
}) => {
  return (
    <Tooltip title={intelligenceText.display_text} arrow placement="top">
      <Box sx={sxStyles.wrapper}>
        <span className={styles.input}>
          <Icons.QBadgeIcon style={{ paddingRight: "0.4rem" }} />{" "}
          {intelligenceText.display_text}
        </span>
      </Box>
    </Tooltip>
  );
};

export default IntelligenceTextDisplay;
